export const getTeacher = ( state ) => {
    return state.teachers
}